module.exports = "pegasus/assets/responsive-card.png";